import styled from "styled-components";
import { colors } from "../../../../../theme/theme";

export const CardButton = styled.div`    
    button { 
        width: 100%;
        padding: 5px;
        border-radius: 16px;
        background-color: transparent;
        border-radius: 4px;
        border: 1px solid ${colors.mainColors.blueberry};
        color: ${colors.mainColors.blueberry};
        height: 39px;
    }
`;

export const MultiSelectFilter = styled.div`
    .multiselect-dropdown{
        width: 100%;
        max-height: 40px;
        font-size: 14px;
    }

    .p-multiselect .p-multiselect-label.p-placeholder{
        color: ${colors.greyscale.grey2};
    }
`;